export default __webpack_public_path__ + "static/media/Javier.9f15d783.jpg";